import { OfferCardSectionT } from "../../../domain";
import { useOffers } from "../../store";
import {
  ArrowIcon,
  Button,
  CaretIcon,
  Menu,
} from "../../../../../shared/infrastructure/ui";
import { OrderTypes, SortByList } from "../../../../../shared/domain";
import React, { useMemo } from "react";

type OfferSortByProps = {
  tab: OfferCardSectionT;
};

export const OfferSortBy = ({
  tab,
}: OfferSortByProps): React.ReactElement<OfferSortByProps> => {
  const { queueFilters, setQueueFilter, historyFilters, setHistoryFilter } =
    useOffers();

  const filters = useMemo(() => {
    if (tab === "queue") return queueFilters;

    return historyFilters;
  }, [historyFilters, queueFilters, tab]);

  const setFilters = useMemo(() => {
    if (tab === "queue") return setQueueFilter;

    return setHistoryFilter;
  }, [setHistoryFilter, setQueueFilter, tab]);

  const toggleOrderBy = (): void => {
    setFilters(
      "order_by",
      filters.order_by === OrderTypes.DESC ? OrderTypes.ASC : OrderTypes.DESC
    );
  };

  const setSortBy = (value: string): void => {
    setFilters("sort_by", value);
    setFilters("order_by", OrderTypes.DESC);
  };

  return (
    <section className="ml-5 grid grid-flow-col items-center rounded-[5px] bg-[#FFFFFF] md:ml-0">
      <Button
        className="w-auto min-w-0 border-0 border-transparent bg-transparent hover:bg-transparent"
        appearance="secondary"
        onClick={() => toggleOrderBy()}
      >
        <ArrowIcon
          className={filters.order_by !== "DESC" ? "rotate-180" : ""}
        />
      </Button>
      <Menu
        name="sort_by"
        defaultValue={"created_at"}
        selectedValue={filters.sort_by}
        items={SortByList}
        renderItem={({ label }) => (
          <section className="grid grid-flow-col items-center gap-[10px] text-[12px] capitalize">
            {label}
          </section>
        )}
        setValue={(_, value) => setSortBy(value)}
      >
        {({ label }) => (
          <Button
            className="w-auto border-0 border-transparent bg-transparent hover:bg-transparent"
            endIcon={<CaretIcon />}
            appearance="secondary"
          >
            {label}
          </Button>
        )}
      </Menu>
    </section>
  );
};
